module.exports = __webpack_public_path__ + "img/Arabic-04.261ad6a7.jpg";